export const gameTypes = {
  'Account Classification': 'classification',
  'Normal Balance': 'normal', 
  'Balanced Equation': 'equation',
  'The Principles': 'principles'
};

export const summaryDecisionBreakdownElementsToDiplay = [
  'Increase', 'Decrease', 'Debit', 'Credit'
];

export const classificationElementsHeaders = ['Balance Sheet', 'Income Statement'];
export const classificationAllOtherAccountsHeaders = ['Assets', 'Liabilities', 'Equity', 'Revenues', 'Expenses'];
export const normalAllOtherAccountsHeaders = ['Debit', 'Credit'];

export const doubleEntryElementsHeaders = [
  'Assets', 'Liabilities', 'Equity'
];

export const principlesElementsHeaders = [
  'Impact on Profits'
];